<div class="message-container blue-fill mb-3">
    <div class="mb-2">
        <mwp-text-translate text="Your employer requires certification that all listed dependents are your legal dependents. Please upload documentation for each dependent that confirms their status as your legal dependent. Acceptable documents include: birth certificates, adoption paperwork, legal guardianship forms, marriage license, etc. For questions regarding what documents are considered acceptable, please contact your HR department." jsonKey="dependentVerifyInstructions" />
    </div>
    <div class="mb-2">
        <mwp-text-translate text="If you do not have the necessary documents to complete the dependent verification at this time, you may continue with your enrollment by clicking the Confirm button and provide the documentation later by using the Dependent Verification option on the menu to the left." jsonKey="dependentVerifyNotice" />
    </div>
    <div>
        <mwp-text-translate text="Please note that failing to provide proper documentation to verify your dependents may result in your dependents being removed from coverage." jsonKey="dependentVerifyWarning" />
    </div>
</div>
<div class="content-container table-comp mb-3">
    <div class="title">
        <mwp-text-translate text="Dependents" jsonKey="dependents" />
    </div>
    <div class="content">
        <mwp-table [tableColumns]="depedentTableColumns" [dataSource]="depedentMatTableData" (emitButtonSelection)="openUploadDocumentDialog($event)" />
    </div>
</div>
<div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" (emitComplete)="complete()" />
</div>